import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPhotosComponent } from "./med-icon-photos.component";

@NgModule({
  declarations: [
    MedIconPhotosComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPhotosComponent,
  ],
})
export class MedIconPhotosModule { }
